@import "../../../../../styles/variables";
@import "../../../../../styles/mixins/svs-design-system";

@mixin topImageForTablets {
  @media (min-width: 780px) and (max-width: 1000px) {
    min-height: 300px;
    width: unset;
  }
}

.offsite-banner {
  @include topImageForTablets;

  background-color: $svs-white;
  color: $svs-anthracite-grey;
  display: flex;
  font-weight: 400;
  margin-bottom: 20px;
  margin-right: 20px;
  text-decoration: none;

  &:hover {
    @include shadow-medium;
  }

  @media (max-width: 1000px) {
    flex-direction: column-reverse;
  }

  @media (max-width: 780px) {
    margin-right: 0;
  }

  &-content {
    box-sizing: border-box;
    margin: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
    flex-basis: 0;

    &__title {
      font-size: 22px;
      line-height: 27px;
      margin: 0;
      word-break: break-word;

      &-colored {
        font-weight: 700;

        &--blue {
          color: $svs-light-sky-blue;
        }

        &--green {
          color: var(--qds-theme-signature-color-default, #008a16);
        }

        &--black {
          color: $svs-anthracite-grey;
        }
      }
    }

    &__main-title {
      margin-right: 6px;
    }

    &__subtitle {
      font-size: 16px;
      line-height: 23px;
      margin-bottom: 0;
      margin-top: 5px;
      white-space: pre-wrap;
    }

    &__button {
      background-color: $svs-light-sky-blue;
      border-radius: 2px;
      display: flex;
      color: white;
      font-size: 16px;
      padding: 10px 15px;
      place-self: baseline;

      @media (max-width: $uiaas-tablet) {
        justify-content: space-around;
        place-self: unset;
      }

      &:hover {
        background-color: $svs-dark-sky-blue;
      }
    }

    &__cta-button {
      margin-top: 24px;
      @media (max-width: $uiaas-tablet) {
        width: 100%;
      }
    }

    &-links {
      margin-top: 7px;

      @media (max-width: 1000px) {
        margin-top: 11px;
        width: 100%;
      }

      &--with-image {
        width: 100%;
      }

      &__single-link {
        align-items: center;
        color: $svs-cta-link;
        display: flex;
        font-size: 14px;
        line-height: 23px;
        margin-top: 9px;
        width: 100%;

        svg {
          margin-right: 12px;
          vertical-align: middle;
        }

        &:visited {
          color: purple;

          path {
            fill: purple;
          }
        }
      }
    }
  }

  &__image {
    @include topImageForTablets;

    background-repeat: round;
    background-size: cover;
    height: auto;
    width: 412px;

    @media (max-width: 399px) {
      height: 100%;
      min-height: 153px;
      width: 100%;
    }
  }
  &-list {
    list-style: none;
    margin: 0;
    padding: 24px 0 0;
  }

  &-list-element {
    margin-top: 12px;
  }
}

.offsite-banner--dashboard-view.offsite-banner {
  margin-right: 0;

  @media (min-width: $uiaas-tablet) and (max-width: 1000px) {
    margin-left: -20px;
  }

  @media (max-width: $uiaas-tablet) {
    margin-top: 20px;
  }

  .offsite-banner {
    &-content__button {
      @media (min-width: $uiaas-tablet) and (max-width: 1000px) {
        justify-content: unset;
        place-self: baseline;
      }
    }

    &__image {
      flex-grow: 1;
      flex-basis: 0;
      background-repeat: no-repeat;
      background-position-x: center;
      background-position-y: center;
      background-size: 100% auto;
      @media (min-width: 1200px) {
        width: 600px;
        min-width: 600px;
        min-height: 300px;
      }

      @media (min-width: 1000px) and (max-width: 1200px) {
        width: 600px;
        min-height: 300px;
        background-position: center;
        background-size: cover;
      }

      @media (min-width: 780px) and (max-width: 1000px) {
        margin-left: auto;
        width: 100%;
      }

      @media (min-width: 550px) and (max-width: 780px) {
        margin-left: auto;
        min-height: 230px;
        width: 100%;
      }

      @media (min-width: 370px) and (max-width: 550px) {
        margin-left: auto;
        min-height: 153px;
        width: 100%;
      }

      @media (max-width: 370px) {
        min-height: 130px;
        width: 100%;
      }
    }
  }
}

.offsite-banner--dashboard-view.offsite-banner--next-to-widget.offsite-banner {
  @media (min-width: 1000px) {
    min-height: 185px;
  }
}

// RTL Handling
[dir="rtl"].offsite-banner {
  .offsite-banner {
    &-content__title {
      display: flex;

      &-colored {
        margin-left: 0;
        margin-right: 6px;
      }
    }
  }
}
